import { FormSelectField, FormInputField, LocalizedText, useFeatureFlag } from '@mews/framework';
import { Banner, Stack } from '@optimus-web/core';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { CommonFormFields } from '../CommonFormFields';
import {
    useLearningPathsOptions,
    useDefaultSuperiorProfileId,
    useDepartmentsOptions,
} from '../../hooks/useCommonFormOptions';
import { useUserType } from '../../hooks/useUserType';
import { createListItems } from '../../utils';
import { FieldNames } from '../FieldNames';
import { SuperiorSearchField } from './SuperiorSearchField';

export const AddUserForm = () => {
    const learningPathsOptions = useLearningPathsOptions();
    const departmentOptions = useDepartmentsOptions();
    const defaultSuperiorProfileId = useDefaultSuperiorProfileId();
    const { isPortfolioCentralUser } = useUserType();
    const employeeIncentiveCodeEnabled = useFeatureFlag(FeatureFlag.employeeIncentiveCodeEnabled);

    return (
        <Stack vertical spacing="400">
            <Stack vertical spacing="200">
                {isPortfolioCentralUser && (
                    <Banner
                        primaryText={<LocalizedText textKey={TextKey.InviteNewCentralUserBannerTitle} />}
                        secondaryText={<LocalizedText textKey={TextKey.InviteNewCentralUserBannerText} />}
                        variant="info"
                    />
                )}

                <FormInputField name={FieldNames.Email} label={<LocalizedText textKey={TextKey.Email} />} required />
                <FormSelectField
                    name={FieldNames.AssignedLearningPath}
                    label={<LocalizedText textKey={TextKey.LearningPath} />}
                    helper={<LocalizedText textKey={TextKey.LearningPathHelper} />}
                    required
                >
                    {createListItems(learningPathsOptions)}
                </FormSelectField>
                {!isPortfolioCentralUser && (
                    <FormSelectField
                        name={FieldNames.DepartmentId}
                        label={<LocalizedText textKey={TextKey.Department} />}
                    >
                        {createListItems(departmentOptions)}
                    </FormSelectField>
                )}
                <SuperiorSearchField preselectedProfileId={defaultSuperiorProfileId} />
                {employeeIncentiveCodeEnabled ? (
                    <FormInputField
                        name={FieldNames.EmployeeIncentiveCode}
                        label={<LocalizedText textKey={TextKey.EmployeeIncentiveCode} />}
                    />
                ) : null}
            </Stack>
            <Stack vertical spacing="200">
                <CommonFormFields />
            </Stack>
        </Stack>
    );
};
